import getAddress from "./3rd-party/apicheck";

let showDebug = true;
console.log('Address Lookup script loaded');

/*
|    ###    ########  ########  ########  ########  ######   ######
|   ## ##   ##     ## ##     ## ##     ## ##       ##    ## ##    ##
|  ##   ##  ##     ## ##     ## ##     ## ##       ##       ##
| ##     ## ##     ## ##     ## ########  ######    ######   ######
| ######### ##     ## ##     ## ##   ##   ##             ##       ##
| ##     ## ##     ## ##     ## ##    ##  ##       ##    ## ##    ##
| ##     ## ########  ########  ##     ## ########  ######   ######

| ##        #######   #######  ##    ## ##     ## ########
| ##       ##     ## ##     ## ##   ##  ##     ## ##     ##
| ##       ##     ## ##     ## ##  ##   ##     ## ##     ##
| ##       ##     ## ##     ## #####    ##     ## ########
| ##       ##     ## ##     ## ##  ##   ##     ## ##
| ##       ##     ## ##     ## ##   ##  ##     ## ##
| ########  #######   #######  ##    ##  #######  ##
*/
// Example addresses:
//     3523 JS, number 31
//     7331 DL, number 122
export default function addressLookup(postalCodeField, houseNumberField, countryField, streetField, cityField) {
	[postalCodeField, houseNumberField, countryField].forEach(field => {
		field.addEventListener("blur", (e) => {
			// Are required fields filled out, AND is the country set to Netherlands?
			if (postalCodeField.value && houseNumberField.value && ['NL','nl','Netherlands','Nederland'].includes(countryField.value) ) {
				getAddress(postalCodeField.value, houseNumberField.value)
				.then(results => {
					if (results.error === true) {
						console.warn(results.description);
					} else {
						let changeEvent = new Event('change');

						streetField.value = results.data.street;
						streetField.dispatchEvent(changeEvent);

						cityField.value = results.data.city;
						cityField.dispatchEvent(changeEvent);
					}
				});
			}
		});
	});
}



const freeformForms = document.querySelectorAll(".jsFreeform");
freeformForms.forEach((formElement) => {
	console.log('Checking freeforms');
	const postalCodeField =
	formElement.querySelector("[id$='Postcode']") ??
	formElement.querySelector("[id$='postcode']");
	const houseNumberField =
	formElement.querySelector("[id$='Huisnummer']") ??
	formElement.querySelector("[id$='huisnummer']");
	const additionField =
	formElement.querySelector("[id$='Toevoeging']") ??
	formElement.querySelector("[id$='toevoeging']");
	const streetField =
	formElement.querySelector("[id$='Straat']") ??
	formElement.querySelector("[id$='straat']");
	const cityField =
	formElement.querySelector("[id$='Plaats']") ??
	formElement.querySelector("[id$='plaats']");
	const countryField =
	formElement.querySelector("[id$='Land']") ??
	formElement.querySelector("[id$='Land2']") ??
	formElement.querySelector("[id$='land']") ??
	formElement.querySelector("[id$='land2']");
	if (
		postalCodeField &&
		houseNumberField &&
		streetField &&
		cityField &&
		countryField
	) {
		if (showDebug) console.warn("Ok to execute address API lookup");
		addressLookup(
			postalCodeField,
			houseNumberField,
			countryField,
			streetField,
			cityField
		);
	} else {
		if (showDebug) console.warn("Can't find all 5 fields for address lookup.");
		if (showDebug) console.log({ postalCodeField });
		if (showDebug) console.log({ houseNumberField });
		if (showDebug) console.log({ streetField });
		if (showDebug) console.log({ cityField });
		if (showDebug) console.log({ countryField });
		return false;
	}
});
